import {UntilDestroy} from "@ngneat/until-destroy";
import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {DynamicFormReadyEvent} from "@mydocma/dynamic-form";
import {TranslateService} from "@ngx-translate/core";

@UntilDestroy()
@Injectable()
export class LayoutEditFieldsService {

  private fieldsFormServices: DynamicFormReadyEvent;
  private attachedSubject = new BehaviorSubject<boolean>(false);

  constructor(private readonly transalteService: TranslateService) {
  }

  public async attachToForm(event: DynamicFormReadyEvent) {
    this.fieldsFormServices = event;
    this.attachedSubject.next(true);
  }

  public validate(): boolean {
    return true;
  }
}
